
import {Component, Prop, Vue} from 'vue-property-decorator';
import {IUsersServicesSumUpCommand} from '@/services/dto/IUsersServicesSumUpCommand';

@Component({})
export default class HomeContent extends Vue {
  @Prop() private service!: IUsersServicesSumUpCommand[];
  @Prop() private brand!: string;
  @Prop() private tooltip?: string;
}
